export enum SheetMaintenanceType {
  CREATION = 'CREATION',
  UPDATE = 'UPDATE',
  DELETION = 'DELETION'
}

